import React from 'react';
import { FormFieldErrors } from 'src/components/riskdetails/hooks';
import ValidationErrors from '../../shared/validation-errors/ValidationErrors';

const FORM_VALIDATION_ERRORS_CONFIG = [
  {
    id: 'risk-name-input-toggle-button',
    labelText: 'Risk Name',
    formFieldErrorKey: 'title',
  },
  {
    id: 'risk-details-input',
    labelText: 'Risk Details',
    formFieldErrorKey: 'details',
  },
  {
    id: 'status-input-toggle-button',
    labelText: 'Status',
    formFieldErrorKey: 'status',
  },
  {
    id: 'priority-input-toggle-button',
    labelText: 'Priority',
    formFieldErrorKey: 'priority',
  },
  {
    id: 'eta-input',
    labelText: 'ETA',
    formFieldErrorKey: 'fixByDate',
  },
];

interface ValidationErrorsProps {
  formFieldErrors: FormFieldErrors;
}

const RiskDetailsValidationErrors = ({ formFieldErrors }: ValidationErrorsProps) => {
  return (
    <ValidationErrors
      errorConfigs={FORM_VALIDATION_ERRORS_CONFIG.map((config) => ({
        ...config,
        isError: formFieldErrors[config.formFieldErrorKey as keyof FormFieldErrors],
      }))}
    />
  );
};

export default RiskDetailsValidationErrors;
